import { conf2AccountId } from "./conf2";
import { guestAccountId } from "./guest-account";
import { identityAccountId } from "./identity-account";

export const anyAccountId = {
  anyOf: [guestAccountId, identityAccountId, conf2AccountId]
};
